
import { Marker } from 'mapbox-gl';
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'mapbox-marker',
    data() {
        return {
            localMarker: null,
        };
    },
    props: {
        map: {
            type: Object,
            required: true,
        },
        lngLat: {
            type: Object,
            required: true,
        },
        selected: {
            type: Boolean,
            default: false,
        },
    },

    watch: {
        lngLat() {
            this._updateMarker();
        },
    },

    mounted() {
        this._updateMarker();
    },

    updated() {
        this._updateMarker();
    },

    methods: {
        _updateMarker() {
            if (this.localMarker) {
                this.localMarker.remove();
            }

            this.localMarker = new Marker({
                element: this.$refs.marker as HTMLElement,
                anchor: 'bottom',
            });

            this.localMarker.setLngLat(this.lngLat).addTo(this.map);
        },
    },

    destroyed() {
        if (this.localMarker) {
            this.localMarker.remove();
        }
    },
});
